import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { BillForm } from '@/components/pages/Admin/BillManagement/Form/BillForm'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/bill/create')({
  component: BillCreatePage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      tab: (search.tab as string) || 'buy',
    }
  },
})

function BillCreatePage() {
  const t = useTranslations('admin.bill_management.create')
  const { tab } = Route.useSearch()

  return (
    <HomeContentContainer title={t('title') + ` (${tab === 'buy' ? 'ซื้อ' : 'ขาย'})`} contentClassName="max-w-full">
      <BillForm action="create" tab={tab} />
    </HomeContentContainer>
  )
}

